import {
  SearchClubNumberedMeetingFragment,
  SearchClubRowFragmentWithNumberedMeetings,
} from '@domain/clubs';

export const getClubMeetings = (
  club: SearchClubRowFragmentWithNumberedMeetings
): SearchClubNumberedMeetingFragment[] => club.meetings || [];
